<template>
  <div class="spl-subpage-header">
    <router-link
      v-if="backLink != null"
      :to="fullBackLink"
      tag="div"
      class="spl-subpage-header__back-arrow" />
    <span
      v-else
      class="spl-subpage-header__back-arrow"
      @click="back_Clicked" />
    <div class="spl-subpage-header__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubpageHeader',
  props: [
    'backLink',
    'label'
  ],
  computed: {
    fullBackLink () {
      if (this.backLink != null) {
        return '/' + this.backLink
      } else {
        return '/'
      }
    }
  },
  methods: {
    back_Clicked () {
      if (this.backLink == null || this.backLink === '') {
        this.$emit('back_Clicked')
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-subpage-header {
        background-color: $yellowButtonLabelHover;
        height: 70px;
        padding: 0 $mainPadding;
        width: 100%;

        &__back-arrow {
            background-color: $middleYellow;
            background-image: url(../../assets/icon-back-arrow.svg);
            background-position: center center;
            background-repeat: no-repeat;
            border-radius: 50%;
            cursor: pointer;
            display: inline-block;
            height: 40px;
            margin-right: 35px;
            margin-top: 15px;
            vertical-align: top;
            width: 40px;
        }
        &__label {
            color: $headerNavHoverColor;
            display: inline-block;
            font-size: 28px;
            line-height: 66px;
            vertical-align: top;
        }
        @include mobile() {
            background-color: $mainInputColor;
            padding: 0 $mobilePadding;
            position: fixed;
            top: 0;
            z-index: 4000;

            &__back-arrow {
                margin-right: 20px;
            }
            &__label {
                font-size: 22px;
            }
        }
    }
</style>
